import React from 'react'
import { Button } from './ui/button'
import { Check, Plus, Save, FileText, ChevronRight } from 'lucide-react'

/**
 * WorkflowNavigator — Clean professional step indicator
 */
const WorkflowNavigator = ({
  activeTab,
  tabConfig,
  getTabStatus,
  canAccessTab,
  onTabChange,
  onNewQuote,
  onSaveQuote,
  savedQuoteId,
  savedQuoteNumber,
}) => {
  if (activeTab === 'dashboard' || activeTab === 'management' || activeTab === 'account' || activeTab === 'apikeys') {
    return null
  }

  return (
    <div className="bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-14">

          {/* Left: Step indicator */}
          <div className="flex items-center gap-1">
            {Object.entries(tabConfig).map(([key, config], idx, arr) => {
              const status = getTabStatus(key)
              const canAccess = canAccessTab(key)
              const isActive = activeTab === key
              const isLast = idx === arr.length - 1

              return (
                <React.Fragment key={key}>
                  <button
                    onClick={() => canAccess && onTabChange(key)}
                    disabled={!canAccess}
                    className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-150 ${
                      isActive
                        ? 'bg-amber-500 text-white'
                        : status === 'complete'
                        ? 'text-slate-500 hover:text-slate-700 hover:bg-slate-100 cursor-pointer'
                        : canAccess
                        ? 'text-slate-500 hover:text-slate-700 hover:bg-slate-100 cursor-pointer'
                        : 'text-slate-300 cursor-not-allowed'
                    }`}
                  >
                    <span className={`flex items-center justify-center w-5 h-5 rounded-full text-xs font-semibold shrink-0 ${
                      isActive
                        ? 'bg-white/30 text-white'
                        : status === 'complete'
                        ? 'bg-emerald-100 text-emerald-700'
                        : 'bg-slate-100 text-slate-500'
                    }`}>
                      {status === 'complete' && !isActive
                        ? <Check className="w-3 h-3" />
                        : config.step
                      }
                    </span>
                    <span className="hidden sm:inline">{config.title}</span>
                  </button>
                  {!isLast && (
                    <ChevronRight className="w-3.5 h-3.5 text-slate-300 shrink-0" />
                  )}
                </React.Fragment>
              )
            })}
          </div>

          {/* Right: Actions */}
          <div className="flex items-center gap-2">
            {savedQuoteId && (
              <div className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-slate-50 border border-slate-200 text-xs text-slate-500">
                <FileText className="h-3.5 w-3.5" />
                <span className="font-medium text-slate-700">{savedQuoteNumber || 'Entwurf'}</span>
              </div>
            )}
            <Button
              onClick={onSaveQuote}
              variant="outline"
              size="sm"
              className="border-slate-200 text-slate-600 hover:bg-slate-50 hover:text-slate-900 gap-1.5 text-xs h-8"
            >
              <Save className="h-3.5 w-3.5" />
              Speichern
            </Button>
            <Button
              onClick={onNewQuote}
              size="sm"
              className="bg-slate-900 hover:bg-slate-800 text-white gap-1.5 text-xs h-8"
            >
              <Plus className="h-3.5 w-3.5" />
              Neues Angebot
            </Button>
          </div>

        </div>
      </div>
    </div>
  )
}

export default WorkflowNavigator
